import React from 'react'
import PropTypes from 'prop-types'
import Form from "react-bootstrap/Form"
import {Col} from "react-bootstrap"
import '../InputDomicilio.css'
import SelectActividades from "../SelectActividades"
import ActividadesSecundarias from "./ActividadesSecundarias"
import { LEGAJO_UNICO } from 'utils/legajo'

const ListadoDomiciliosEstaticosHooks = (props) => {
  const idElemento = controlId => controlId + controlId
  return (
    <>
      {props.listado.map((dato, index) => {
        return (<div className='input-domicilio' key={dato.id}>
          <Form.Row>
            <Col md={6}>
                <Form.Group controlId={idElemento('formCalle')+index}>
                  <Form.Label>Calle (Domicilio {index + 1})</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={dato.calle}
                    ref={props.register({required:true})}
                    disabled={props.isDisabled}
                    name={`${props.nombre}[${index}].calle`}
                  />
                </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Row>
                <Col md={4}>
                  <Form.Group controlId={idElemento("formNumeroCalle")+index}>
                    <Form.Label>Numero </Form.Label>
                    <Form.Control
                      type="number"
                      defaultValue={dato.numero}
                      ref={props.register({required:true})}
                      placeholder="Número"
                      disabled={props.isDisabled}
                      name={`${props.nombre}[${index}].numero`}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId={idElemento("formPiso")+index}>
                    <Form.Label>Piso </Form.Label>
                    <Form.Control
                      type="number"
                      defaultValue={dato.piso}
                      ref={props.register()}
                      disabled={props.isDisabled}
                      name={`${props.nombre}[${index}].piso`}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId={idElemento("formCodigoPostal")+index}>
                    <Form.Label>CP</Form.Label>
                    <Form.Control
                      type="text"
                      defaultValue={dato.codigoPostal}
                      ref={props.register({required:true})}
                      disabled={props.isDisabled}
                      name={`${props.nombre}[${index}].codigoPostal`}
                    />
                  </Form.Group>
                </Col>
              </Form.Row>
            </Col>
            <Col md={6} style={{display: dato.partidaInmobiliaria ? 'block' : 'none'}}>
                <Form.Group controlId={idElemento("formPartidaDomiciliaria")+index}>
                    <Form.Label>Partida Inmobiliaria </Form.Label>
                    <Form.Control
                        type="text"
                        defaultValue={dato.partidaInmobiliaria}
                        ref={props.register({required:true})}
                        disabled={props.isDisabled}
                        name={`${props.nombre}[${index}].partidaInmobiliaria`}
                    />
                </Form.Group>
            </Col>
            <Col md={6} style={{display: dato.legajo.legajo === LEGAJO_UNICO ? 'none': 'block'}}>
              <Form.Group controlId={'formLegajo-' + index}>
                  <Form.Label>Legajo para Domicilio N°{index + 1}</Form.Label>
                  <Form.Control
                      type="text"
                      defaultValue={dato.legajo.legajo}
                      disabled={props.isDisabled}
                      ref={props.register({required:true})}
                      name={`${props.nombre}[${index}].legajo.legajo`}
                  />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId={"formLegajo-" + index + 'actividadPpal'}>
                <Form.Label>Actividad Principal para Domicilio N°{index + 1}</Form.Label>
                  <SelectActividades
                    actividades={props.actividades}
		    actividadesiibb={props.actividadesiibb}
                    defaultValue={dato.legajo.actividadPrincipal}
                    register={() => props.register({required:true})}
                    name={`${props.nombre}[${index}].legajo.actividadPrincipal`}
                    isDisabled={props.isDisabled}
		  />
              </Form.Group>
            </Col>
              <ActividadesSecundarias
                  listado={`${props.nombre}[${index}]`}
                  isValid={() => props.errors?.[props.donde]?.domicilioComercial?.[index]?.legajo?.actividadSecundaria}
                  getValues={() => {}}
                actividades={props.actividades}
		actividadesiibb={props.actividadesiibb}
                  isHabilitacion={false}
                  isDisabled={props.isDisabled}
                  control={props.control}
                  nestIndex={index}
                  register={props.register}
              />
          </Form.Row>
        </div>)
      })
      }
    </>)
}

ListadoDomiciliosEstaticosHooks.propTypes = {
  isDisabled : PropTypes.bool,
  donde: PropTypes.string.isRequired,
  listado: PropTypes.array.isRequired,
  nombre: PropTypes.string.isRequired,
  append: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired
}

ListadoDomiciliosEstaticosHooks.defaultProps = {
  isDisabled : false
}

export default ListadoDomiciliosEstaticosHooks
